export const AT_DOJOMAP_GET_DOJOS_SUCCESS = 'AT_DOJOMAP_GET_DOJOS_SUCCESS';
export const AT_DOJOMAP_GET_DOJOS_FAILURE = 'AT_DOJOMAP_GET_DOJOS_FAILURE';
